// VExpansionPanel can v-model a prop to programatically control which panels are open/closed.
// This is either an Array of the panel indices or a single index value for one panel.
// Since we only have one panel (index 0), we can use `0` to open and `null` to close.
export const PANEL_OPEN = 0;
export const PANEL_CLOSED = null;
export type PanelState = typeof PANEL_OPEN | typeof PANEL_CLOSED;